import CopyrightStatement from './CopyrightStatement'

export default CopyrightStatement



// WEBPACK FOOTER //
// ./src/legacy/components/CopyrightStatement/index.js